module.exports = __webpack_public_path__ + "static/media/user.b484ba8d.svg";